import {
  Gift, HandCoins, ShoppingBag, Download, BookOpen, Scroll, CalendarDays,
  Utensils, Wine, Flame, Landmark, Ticket, MapPin, Users, MessageCircle,
  Globe, Link as LinkIcon,
} from "lucide-react";

// Curated icon set — mostly holiday / synagogue / meal / contribution themed.
export const RESOURCE_ICONS = {
  gift: { comp: Gift, label: "Gift" },
  donate: { comp: HandCoins, label: "Donation / Tzedakah" },
  shop: { comp: ShoppingBag, label: "Shop / Order" },
  download: { comp: Download, label: "Download / PDF" },
  book: { comp: BookOpen, label: "Prayer book / Study" },
  scroll: { comp: Scroll, label: "Torah / Scroll" },
  meal: { comp: Utensils, label: "Meal / Dinner" },
  wine: { comp: Wine, label: "Kiddush / Wine" },
  candle: { comp: Flame, label: "Candles / Lighting" },
  synagogue: { comp: Landmark, label: "Synagogue / Services" },
  calendar: { comp: CalendarDays, label: "Schedule / Event" },
  ticket: { comp: Ticket, label: "Tickets / RSVP" },
  location: { comp: MapPin, label: "Location" },
  community: { comp: Users, label: "Family / Community" },
  contact: { comp: MessageCircle, label: "Contact / WhatsApp" },
  website: { comp: Globe, label: "Website (external)" },
  link: { comp: LinkIcon, label: "Generic link" },
};

export const DEFAULT_RESOURCE_ICON = "gift";

const has = (s, words) => words.some((w) => s.includes(w));

// Smart default based on the link and label text.
export function autoResourceIcon(url = "", label = "") {
  const u = (url || "").toLowerCase();
  const l = (label || "").toLowerCase();
  const t = `${u} ${l}`;

  if (u.startsWith("#donate") || has(t, ["donat", "contribut", "tzedak", "charity", "sponsor", "pledge"])) return "donate";
  if (has(t, ["menorah", "candle", "light"])) return "candle";
  if (has(t, ["torah", "scroll", "megill", "parsha"])) return "scroll";
  if (has(t, ["siddur", "machzor", "prayer book", "prayerbook", "study", "learn", "book"])) return "book";
  if (has(t, ["kiddush", "lechaim", "l'chaim", "wine", "grape"])) return "wine";
  if (has(t, ["meal", "dinner", "lunch", "feast", "seder", "seud", "bbq", "banquet", "brunch", "matza", "matzah", "challah", "food", "kosher"])) return "meal";
  if (has(t, ["synagogue", "shul", "minyan", "service", "prayer time", "davening"])) return "synagogue";
  if (has(t, ["ticket", "rsvp", "register", "sign up", "sign-up", "signup", "reserve"])) return "ticket";
  if (u.includes("download") || u.endsWith(".pdf") || has(l, ["download", "schedule", "guide", "pdf", "brochure", "flyer"])) return "download";
  if (has(t, ["shop", "buy", "order", "store", "purchase", "cart"])) return "shop";
  if (u.startsWith("/events") || has(l, ["event", "calendar", "when", "times"])) return "calendar";
  if (has(l, ["location", "address", "map", "where", "directions"])) return "location";
  if (u.startsWith("mailto:") || u.startsWith("tel:") || u.startsWith("#contact") || has(l, ["contact", "whatsapp", "call", "email", "message"])) return "contact";
  if (u.startsWith("http")) return "website";
  if (u.startsWith("#") || u.startsWith("/")) return "link";
  return DEFAULT_RESOURCE_ICON;
}

// Resolve the icon component for a resource: explicit choice → smart default.
export function resourceIconComp(resource = {}) {
  const key = resource.icon && RESOURCE_ICONS[resource.icon] ? resource.icon : autoResourceIcon(resource.url, resource.label);
  return (RESOURCE_ICONS[key] || RESOURCE_ICONS[DEFAULT_RESOURCE_ICON]).comp;
}
